import React, { useEffect, useRef, useState } from "react";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import * as func from "../../common/manipurCommon/FunctionCalls";
import * as api from "../../common/manipurCommon/API";
import { usePermissions } from "../../common/PermissionContext";
import { useLocation, Link } from "react-router-dom";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import Select from "react-select";
import Swal from "sweetalert2";
import Utils from "../../common/manipurCommon/Utils";

const Menus = () => {

    const [menuList, setMenuList] = useState<any[]>([]);
    const [accountTypeList, setAccountTypeList] = useState<any[]>([]);
    const [searchInput, setSearchInput] = useState("");
    const [menuId, setMenuId] = useState("");
    const [accountTypeId, setAccountTypeId] = useState("");
    const [menuTitle, setMenuTitle] = useState("");
    const [menuRoute, setMenuRoute] = useState("");
    const [menuOrder, setMenuOrder] = useState("");
    const [menuStatus, setMenuStatus] = useState("");
    const [hasAccess, setHasAccess] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false);

    const formRef = useRef(null);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    const customSelect = {
        control: (base) => ({
            ...base,
            // padding: '20px',
            borderRadius: '10px',
            background: '#FAFAFA',
            border: '1px solid hsl(0, 0%, 80%)',
            boxShadow: 'none', // prevents default blue border on focus
            minHeight: 'unset', // optional: removes default height if needed
        }),
        placeholder: (base) => ({
            ...base,
            color: '#aaa',
        }),
        singleValue: (base) => ({
            ...base,
            color: '#333',
        }),
        menu: (base) => ({
            ...base,
            zIndex: 9999,
        }),
    }

    useEffect(() => {
        fetchMenus();
    }, [])

        async function fetchMenus() {
            setIsLoading(true);
            const menuResponse = await func.listMenus();
            setMenuList(Array.isArray(menuResponse) ? menuResponse : [])
            setIsLoading(false);
        }

    const filteredData = menuList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const menuRender = (rowData) => {
        return <span>{rowData.menuTitle}</span>;
    };

    const menuRouteRender = (rowData) => {
        return <span>{rowData.menuRoute}</span>;
    };

    const menuOrderRender = (rowData) => {
        return <span>{rowData.menuOrder}</span>;
    };

    const menuStatusRender = (rowData) => {
        return <span>{(rowData.menuStatus == 1) ? "Active" : "Inactive"}</span>;

    };

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editMenu(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    const deleteDetails = (rowData) => {
        const menuId = rowData.menuId;

        return (
            <Link to="#" onClick={() => deleteMenu(menuId)}>
                <i className="feather-trash"></i>Delete
            </Link>
        );
    };

    async function newMenu() {
        setIsEdit(false)
        setOpenModal(true)
        const accResponse = await func.accountType(null);
        setAccountTypeList(Array.isArray(accResponse) ? accResponse : [])
        setMenuTitle("");
        setMenuRoute("");
        setMenuOrder("");
        setAccountTypeId("");
        setHasAccess("");
    }


    async function editMenu(rowData: { menuId: any; }) {
        const mnuId = rowData.menuId;
        setIsEdit(true)
        setOpenModal(true)
        const accResponse = await func.accountType(null);
        setAccountTypeList(Array.isArray(accResponse) ? accResponse : [])
        const getDetails = await func.getMenu(mnuId);
        setMenuId(mnuId)
        setMenuTitle(getDetails.menuTitle);
        setMenuRoute(getDetails.menuRoute);
        setMenuOrder(getDetails.menuOrder);
        setMenuStatus(getDetails.menuStatus);
        setAccountTypeId(getDetails.accountAccess);
        setHasAccess(getDetails.hasSubmenuAccess);
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateMenu();
            } else {
                if (menuTitle && menuRoute && menuOrder) {
                    const formData = new FormData();
                    formData.append("hasSubmenuAccess", hasAccess);
                    formData.append("menuTitle", menuTitle);
                    formData.append("menuRoute", menuRoute);
                    formData.append("menuOrder", menuOrder);
                    formData.append("accountAccess", accountTypeId);


                    const createMenu = api.AddMenu;
                    fetch(createMenu, {
                        method: "POST",
                        headers: {
                            "Authorization": 'Bearer ' + Utils.getAccessToken()
                        },
                        body: formData
                    })
                        .then((response) => response.json())
                        .then((result) => {
                            if (result.error == false) {
                                Swal.fire({
                                    title: 'Success',
                                    text: result.message,
                                    icon: 'success',
                                    confirmButtonText: 'OK',
                                    allowOutsideClick: false,
                                    allowEscapeKey: false
                                }).then((res) => {
                                    if (res.isConfirmed) {
                                        // window.location.reload(); // 🔁 Reload only after OK is clicked
                                        setOpenModal(false);
                                        fetchMenus();
                                    }
                                });
                            } else {
                                if (result.code == 401) {
                                    Utils.logoutUser();
                                }
                                Swal.fire({
                                    title: 'Error',
                                    text: result.message,
                                    icon: 'error',
                                    confirmButtonText: 'OK',
                                    allowOutsideClick: false,
                                    allowEscapeKey: false
                                })
                            }
                        })
                }
            }
        }
    }

    function updateMenu() {
        const formData = new FormData();
        formData.append("hasSubmenuAccess", hasAccess);
        formData.append("menuTitle", menuTitle);
        formData.append("menuRoute", menuRoute);
        formData.append("menuOrder", menuOrder);
        formData.append("menuStatus", menuStatus);
        formData.append("accountAccess", accountTypeId);

        const updateMenu = api.UpdateMenu + '/' + menuId;
        fetch(updateMenu, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            // window.location.reload(); // 🔁 Reload only after OK is clicked
                            setIsEdit(false);
                            setOpenModal(false);
                            fetchMenus();
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })
    }

    function deleteMenu(mnuId) {
        const deleteMenu = api.DeleteMenu + '/' + mnuId;
        fetch(deleteMenu, {
            method: "DELETE",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            // window.location.reload(); // 🔁 Reload only after OK is clicked
                            setOpenModal(false);
                            fetchMenus();
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })

    }

    return (
        <>
            {isLoading && (

                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1500px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Menus</h4>
                                    {currentPermissions.includes("add") ?
                                        <Link
                                            to="#"
                                            className="btn"
                                            onClick={() => { newMenu() }}
                                            data-bs-toggle="tooltip"
                                            style={{ fontSize: "24px", padding: "0px" }}
                                            title="Create Menu">
                                            <i className="feather-plus" />&nbsp;
                                        </Link>
                                        : null
                                    }
                                </div>
                            </div>
                            <div className="row col-lg-12 mb-10">
                                <div className="col-lg-12 text-end dataTables_filter">
                                    <label>
                                        <input
                                            type="text"
                                            value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                            style={{ height: "40px" }}
                                            placeholder="Search"
                                            className="form-control"
                                        />
                                    </label>
                                </div>
                                {/* </div> */}
                            </div>
                            <div className="tab-content">
                                <div
                                    className="tab-pane fade show active"
                                    id="nav-Recent"
                                    role="tabpanel"
                                    aria-labelledby="nav-Recent-tab"
                                    tabIndex={0}
                                >
                                    <div className="table-responsive table-datatble">
                                        <DataTable
                                            className="table datatable"
                                            value={filteredData}
                                            paginator
                                            rows={10}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            pageLinkSize={3}
                                        >
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="slNo"
                                                body={slNoRender}
                                                header="Sl &nbsp; No"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="menuTitle"
                                                header="Menu Name"
                                                body={menuRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="menuRoute"
                                                header="Menu Route"
                                                body={menuRouteRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="menuOrder"
                                                header="Menu Order"
                                                body={menuOrderRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="menuStatus"
                                                header="Menu Status"
                                                body={menuStatusRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            {currentPermissions.includes("edit") ?
                                                <Column
                                                    className="text-link"
                                                    body={editDetails}
                                                ></Column>
                                                : null
                                            }
                                            {currentPermissions.includes("delete") ?
                                                <Column
                                                    className="text-link"
                                                    body={deleteDetails}
                                                ></Column>
                                                : null
                                            }
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {
                openModal && (
                    <Modal
                        show={openModal}
                        size="md"
                        centered>
                        <ModalHeader>
                            <ModalTitle>
                                <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Add "} Menu</h4>
                            </ModalTitle>
                            <Button
                                variant=""
                                className="btn-close"
                                onClick={() => setOpenModal(false)}
                            ></Button>
                        </ModalHeader>
                        <ModalBody>
                            <form ref={formRef}>
                                <div className="col-lg-12 mb-10">
                                    <label className="form-label">Account Access</label>
                                    <Select
                                        value={accountTypeList.find(acc => acc.accountTypeId === accountTypeId) ? {
                                            value: accountTypeId,
                                            label: accountTypeList.find(acc => acc.accountTypeId === accountTypeId)?.accountName
                                        } : null}
                                        onChange={(e) => { setAccountTypeId(e.value) }}
                                        styles={customSelect}
                                        required
                                        placeholder="Select Account Type"
                                        options={accountTypeList.map(acc => ({
                                            value: acc.accountTypeId,
                                            label: acc.accountName
                                        }))}>
                                    </Select>
                                </div>
                                <div className="col-lg-12 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Menu Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            required
                                            style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                            id="menuName"
                                            value={menuTitle}
                                            onChange={(e) => setMenuTitle(e.target.value)}
                                            placeholder="Menu Name" />
                                    </div>
                                </div>

                                <div className="col-lg-12 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Menu Route</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            required
                                            style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                            id="menuRoute"
                                            value={menuRoute}
                                            onChange={(e) => setMenuRoute(e.target.value)}
                                            placeholder="Menu Route" />
                                    </div>
                                </div>
                                <div className="col-lg-12 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Menu Order</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            required
                                            style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                            id="menuOrder"
                                            value={menuOrder}
                                            onChange={(e) => setMenuOrder(e.target.value)}
                                            placeholder="Menu Order" />
                                    </div>
                                </div>
                                <div className="col-lg-12 mb-10">
                                    <div className="input-space">
                                        <div className="row">
                                            <div className="mb-10 col-lg-4" style={{ paddingTop: "1rem" }}>
                                                <label className="form-label">Has Menu Access</label>
                                            </div>
                                            <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                                <div className="form-check form-switch d-flex align-items-center justify-content-end">
                                                    <input
                                                        className="form-check-input text-end"
                                                        type="checkbox"
                                                        required
                                                        checked={hasAccess === '1'}
                                                        id="hasAccess"
                                                        onChange={(e) => {
                                                            setHasAccess(e.target.checked ? '1' : '0')
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {isEdit ?
                                    <>
                                        <div className="row">
                                            <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                                <label className="form-label">Status</label>
                                            </div>
                                            <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                                <div className="form-check form-switch d-flex align-items-center justify-content-end">
                                                    <input
                                                        className="form-check-input text-end"
                                                        type="checkbox"
                                                        checked={menuStatus === '1'}
                                                        id="menuStatus"
                                                        onChange={(e) => {
                                                            setMenuStatus(e.target.checked ? '1' : '0')
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </> : null
                                }
                                <ModalFooter>
                                    <Button
                                        className="btn-primary text-uppercase"
                                        variant="success"
                                        type="submit"
                                        onClick={handleSubmit}
                                    >
                                        <b><i className="fas fa-save" />Save</b>
                                    </Button>
                                </ModalFooter>
                            </form>
                        </ModalBody>
                    </Modal>
                )
            }
        </>
    );
};

export default Menus;